import styled from "styled-components";

const DoubleItemBoxStyled = styled.div`
background-color: white;
color: white;
border-radius: 20px;
border-color: aliceblue;
box-shadow: rgba(97, 97, 97, 0.1) 0px 0px 16px;
padding: 3rem 5rem;

.title {
    font-size: 1.7rem;
    color: black;
    margin-bottom: 7;
    font-weight: 400;
}
`

export default DoubleItemBoxStyled;
